import * as fabric from 'fabric'

/**
 * Disegna le quote dimensionali (larghezza/altezza) della print area.
 *
 * Perche' serve:
 * - rende esplicito in editor l'ingombro reale in cm della zona stampabile;
 * - e' un overlay tecnico escluso da export/persistenza dell'artwork utente.
 */
export const addPrintAreaQuote = (
  canvas: fabric.Canvas,
  areaStampa: fabric.Object,
  larghezzaAreaStampa: number,
  altezzaAreaStampa: number
) => {
  const bound = areaStampa.getBoundingRect()
  const offset = 60

  const testoLarghezzaCm = `${larghezzaAreaStampa} cm`
  const testoAltezzaCm = `${altezzaAreaStampa} cm`

  const createQuote = (
    startX: number,
    startY: number,
    endX: number,
    endY: number,
    testo: string,
    isOrizzontale: boolean
  ) => {
    const coloreQuota = '#9E9E9E'
    const coloreTesto = '#000000'
    const spessoreLinea = 5
    const tickExtent = 30
    const paddingTesto = 36
    const coloreSfondoLabel = '#EDEDF0'
    const raggioArrotondamentoBox = 15
    const halfStroke = spessoreLinea / 2

    const stileLinea = {
      stroke: coloreQuota,
      strokeWidth: spessoreLinea,
      selectable: false,
      evented: false,
      strokeLineCap: 'butt' as const,
    }

    const textContent = new fabric.FabricText(testo, {
      fill: coloreTesto,
      fontSize: 84,
      fontFamily: 'sans-serif',
      selectable: false,
      evented: false,
    })

    const textDims = textContent.getBoundingRect()
    const textBackgroundRect = new fabric.Rect({
      fill: coloreSfondoLabel,
      rx: raggioArrotondamentoBox,
      ry: raggioArrotondamentoBox,
      width: textDims.width + 80,
      height: textDims.height + 40,
      selectable: false,
      evented: false,
    })

    textContent.set({
      left: textBackgroundRect.width / 2,
      top: textBackgroundRect.height / 2,
      originX: 'center',
      originY: 'center',
    })

    const labelGroup = new fabric.Group([textBackgroundRect, textContent], {
      selectable: false,
      evented: false,
      excludeFromImage: true,
    } as any)

    let tickInizio: fabric.Line
    let tickFine: fabric.Line
    let lineaPrincipale: fabric.Line

    if (isOrizzontale) {
      const adjustedStartX = startX + halfStroke
      const adjustedEndX = endX - halfStroke
      const lineY = startY

      tickInizio = new fabric.Line(
        [adjustedStartX, lineY - tickExtent, adjustedStartX, lineY + tickExtent],
        stileLinea
      )
      tickFine = new fabric.Line(
        [adjustedEndX, lineY - tickExtent, adjustedEndX, lineY + tickExtent],
        stileLinea
      )
      lineaPrincipale = new fabric.Line([adjustedStartX, lineY, adjustedEndX, lineY], stileLinea)

      labelGroup.set({
        left: (startX + endX) / 2,
        top: lineY - paddingTesto,
        originX: 'center',
        originY: 'bottom',
      })
    } else {
      const adjustedStartY = startY + halfStroke
      const adjustedEndY = endY - halfStroke
      const lineX = startX

      tickInizio = new fabric.Line(
        [lineX - tickExtent, adjustedStartY, lineX + tickExtent, adjustedStartY],
        stileLinea
      )
      tickFine = new fabric.Line(
        [lineX - tickExtent, adjustedEndY, lineX + tickExtent, adjustedEndY],
        stileLinea
      )
      lineaPrincipale = new fabric.Line([lineX, adjustedStartY, lineX, adjustedEndY], stileLinea)

      labelGroup.set({
        left: lineX - paddingTesto,
        top: (startY + endY) / 2,
        originX: 'right',
        originY: 'center',
      })
    }

    return new fabric.Group([tickInizio, lineaPrincipale, labelGroup, tickFine], {
      selectable: false,
      evented: false,
      excludeFromImage: true,
    } as any)
  }

  const quotaLarghezza = createQuote(
    bound.left,
    bound.top - offset,
    bound.left + bound.width,
    bound.top - offset,
    testoLarghezzaCm,
    true
  )

  const quotaAltezza = createQuote(
    bound.left - offset,
    bound.top,
    bound.left - offset,
    bound.top + bound.height,
    testoAltezzaCm,
    false
  )

  const quotaObj = new fabric.Group([quotaLarghezza, quotaAltezza], {
    customId: 'quota',
    selectable: false,
    evented: false,
    excludeFromImage: true,
  } as any)

  canvas.add(quotaObj)
}
